import { useState } from 'react';

import styles from './CustomTextField.module.css';

interface CustomTextFieldProps {
    id: string;
    label: string;
    onChange: (event: { target: { id: string; value: string } }) => void;
    value?: string;
    rows?: number;
    setGlobalError?: (hasError: boolean) => void;
}

const MAX_LENGTH = 300;

export function CustomTextField({ id, label, onChange, value, rows = 1, setGlobalError }: CustomTextFieldProps) {
    const [error, setError] = useState(false);

    const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (event.target.value.length <= MAX_LENGTH) {
            onChange({ target: { id: event.target.id, value: event.target.value } });
            setError(false);
            setGlobalError?.(false);
        } else {
            setError(true);
            setGlobalError?.(true);
        }
    };

    const textareaClassName = `${styles.textarea} ${error ? styles.textareaError : ''}`;

    return (
        <div className={styles.textFieldWrapper}>
            <label htmlFor={id} className={styles.label}>{label}</label>
            <textarea
                id={id}
                className={textareaClassName}
                value={value}
                onChange={handleInputChange}
                rows={rows}
            />
            {error && <span className={styles.helperText}>Не більше 300 символів</span>}
        </div>
    );
}
